import React from 'react';

import Box from '@material-ui/core/Box';
import MUIContainer from '@material-ui/core/Container';
import Alert from '@material-ui/lab/Alert';

export default function Container({ children, error = false, ...rest }) {
  if (error && typeof error !== 'string') {
    error = 'Encontramos um problema ao exibir os dados. Tente novamente em alguns instantes.';
  }

  return (
    <Box py={2} {...rest}>
      <MUIContainer>{!error ? children : <Alert severity="error">{error}</Alert>}</MUIContainer>
    </Box>
  );
}
